export default __webpack_public_path__ + "static/lifetime-app-4db9b95665e86090afc7aa45ee7f17e4.jpg";